import { schemes, zSchema } from "@zeal/common";

export const deleteContractorPaymentDeductionRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  contractorPaymentID: schemes.mongoObjectId(),
  deductionID: schemes.mongoObjectId(),
});

export type TDeleteContractorPaymentDeductionRequest = zSchema.infer<
  typeof deleteContractorPaymentDeductionRequestSchema
>;
